export default {
  "Client": "Client Authorization Instructions (Confirmation.com).pdf",
  "一汽财务有限": "一汽财务有限公司 (First Automobile Finance).pdf",
  "上海农村商业": "上海农村商业银行股份有限公司 (SHRCB).pdf",
  "上海浦东发展": "上海浦东发展银行股份有限公司 (SPD Bank).pdf",
  "东亚银行（中": "东亚银行（中国）有限公司 (BEA).pdf",
  "东营莱商村镇": "东营莱商村镇银行股份有限公司 (Dongying Laishang Rural Bank).pdf",
  "东营银行股份": "东营银行股份有限公司 (Dongying Bank).pdf",
  "中信银行股份": "中信银行股份有限公司 (CITIC).pdf",
  "中国光大银行": "中国光大银行股份有限公司 (CEB).pdf",
  "中国农业发展": "中国农业发展银行 (ADBC).pdf",
  "中国农业银行": "中国农业银行股份有限公司 (ABC).pdf",
  "中国工商银行": "中国工商银行股份有限公司 (ICBC).pdf",
  "中国建设银行": "中国建设银行股份有限公司 (CCB).pdf",
  "中国民生银行": "中国民生银行股份有限公司 (CMBC).pdf",
  "中国进出口银": "中国进出口银行 (The Export - Import Bank of China).pdf",
  "中国邮政储蓄": "中国邮政储蓄银行股份有限公司 (PSBC).pdf",
  "中国银行股份": "中国银行股份有限公司 (BOC).pdf",
  "中核财务有限": "中核财务有限责任公司 (CNNC).pdf",
  "临商银行股份": "临商银行股份有限公司 (Linshang Bank).pdf",
  "云南红塔银行": "云南红塔银行股份有限公司 (Yunnan Hongta Bank).pdf",
  "交通银行股份": "交通银行股份有限公司 (BOCOM).pdf",
  "保定银行股份": "保定银行股份有限公司 (Bank of Baoding).pdf",
  "兴业银行股份": "兴业银行股份有限公司 (CIB).pdf",
  "内蒙古银行股": "内蒙古银行股份有限公司 (Bank of Inner Mongolia).pdf",
  "北京中关村银": "北京中关村银行股份有限公司 (Zhongguancun Bank).pdf",
  "北京银行股份": "北京银行股份有限公司 (Bank of Beijing).pdf",
  "华侨银行有限": "华侨银行有限公司 (OCBC).pdf",
  "华夏银行股份": "华夏银行股份有限公司 (Huaxia Bank).pdf",
  "南京银行股份": "南京银行股份有限公司 (Bank of Nanjing).pdf",
  "厦门国贸控股": "厦门国贸控股集团财务有限公司 (ITG).pdf",
  "厦门国际银行": "厦门国际银行股份有限公司 (Xiamen International Bank).pdf",
  "哈尔滨银行股": "哈尔滨银行股份有限公司 (Haerbin Bank).pdf",
  "唐山银行股份": "唐山银行股份有限公司 (BOTS).pdf",
  "四川新网银行": "四川新网银行股份有限公司 (SICHUAN XW BANK).pdf",
  "国家开发银行": "国家开发银行 (China Development Bank).pdf",
  "天津武清村镇": "天津武清村镇银行股份有限公司 (Tianjin Wuqing County Bank).pdf",
  "威海市商业银": "威海市商业银行股份有限公司 (Weihai Bank).pdf",
  "威海蓝海银行": "威海蓝海银行股份有限公司 (Blue Ocean Bank).pdf",
  "宁夏银行股份": "宁夏银行股份有限公司 (Bank of Ningxia).pdf",
  "宁波东海银行": "宁波东海银行股份有限公司 (Ningbo Donghai Bank).pdf",
  "宁波通商银行": "宁波通商银行股份有限公司 (Ningbo Commerce Bank).pdf",
  "宁波银行股份": "宁波银行股份有限公司 (Bank of Ningbo).pdf",
  "宝武集团财务": "宝武集团财务有限责任公司 (Baowu).pdf",
  "山东港口集团": "山东港口集团财务有限责任公司 (Shandong Port Group).pdf",
  "平安银行股份": "平安银行股份有限公司 (Ping An Bank).pdf",
  "广东华兴银行": "广东华兴银行股份有限公司 (GHB).pdf",
  "广东南粤银行": "广东南粤银行股份有限公司 (Guangdong Nanyue Bank).pdf",
  "广发银行股份": "广发银行股份有限公司 (CGB).pdf",
  "广州农村商业": "广州农村商业银行股份有限公司 (Guangzhou Rural Commercial Bank).pdf",
  "广州汽车集团": "广州汽车集团财务有限公司 (GAC Finance).pdf",
  "广州银行股份": "广州银行股份有限公司 (Bank of Guangzhou).pdf",
  "广西北部湾银": "广西北部湾银行股份有限公司 (Guangxi Beibu Gulf Bank).pdf",
  "德州银行股份": "德州银行股份有限公司 (Dezhou Bank).pdf",
  "徽商银行股份": "徽商银行股份有限公司 (Huishang Bank).pdf",
  "招商局集团财": "招商局集团财务有限公司 (China Merchants Group Finance Co., LTD.).pdf",
  "招商银行股份": "招商银行股份有限公司 (CMB).pdf",
  "无锡锡商银行": "无锡锡商银行股份有限公司 (Wuxi Xishang Bank).pdf",
  "日照银行股份": "日照银行股份有限公司 (Bank of Rizhao).pdf",
  "昆仑银行股份": "昆仑银行股份有限公司 (Bank of Kunlun).pdf",
  "曲靖惠民村镇": "曲靖惠民村镇银行股份有限公司 (Qujing Huimin Village Bank).pdf",
  "杭州银行股份": "杭州银行股份有限公司 (Bank of Hangzhou).pdf",
  "汇丰银行（中": "汇丰银行（中国）有限公司 (HSBC).pdf",
  "江苏苏商银行": "江苏苏商银行股份有限公司 (SMB).pdf",
  "江苏银行股份": "江苏银行股份有限公司 (Bank of Jiangsu).pdf",
  "河北银行股份": "河北银行股份有限公司 (Bank of Hebei).pdf",
  "泰安银行股份": "泰安银行股份有限公司 (Taian Bank).pdf",
  "济宁儒商村镇": "济宁儒商村镇银行股份有限公司 (Jining Rushang Rural Bank).pdf",
  "济宁银行股份": "济宁银行股份有限公司 (Bank of Jining).pdf",
  "浙商银行股份": "浙商银行股份有限公司 (CZB).pdf",
  "浙江民泰商业": "浙江民泰商业银行股份有限公司 (Zhejiang Mintai Commercial Bank).pdf",
  "浙江泰隆商业": "浙江泰隆商业银行 (Tailong Commercial Bank).pdf",
  "浙江网商银行": "浙江网商银行股份有限公司 (Zhejiang Wangshang Bank).pdf",
  "海信集团财务": "海信集团财务有限公司 (Hisense).pdf",
  "海南银行股份": "海南银行股份有限公司 (Bank of Hainan).pdf",
  "海尔集团财务": "海尔集团财务有限责任公司 (Haier).pdf",
  "深圳前海微众": "深圳前海微众银行股份有限公司 (WeBank).pdf",
  "渤海银行股份": "渤海银行股份有限公司 (China Bohai Bank).pdf",
  "湖南三湘银行": "湖南三湘银行股份有限公司 (Bank of Sanxiang).pdf",
  "潍坊银行股份": "潍坊银行股份有限公司 (Bank of Weifang).pdf",
  "烟台银行股份": "烟台银行股份有限公司 (Yantai Bank).pdf",
  "甘肃银行股份": "甘肃银行股份有限公司 (Bank of Gansu).pdf",
  "盘锦银行股份": "盘锦银行股份有限公司 (Bank of Panjin).pdf",
  "石嘴山银行股": "石嘴山银行股份有限公司 (Bank of Shizuishan).pdf",
  "福建海峡银行": "福建海峡银行股份有限公司 (Haixia Bank of Fujian).pdf",
  "绍兴银行股份": "绍兴银行股份有限公司 (BSX).pdf",
  "苏州银行股份": "苏州银行股份有限公司 (Bank of Suzhou).pdf",
  "莱商银行股份": "莱商银行股份有限公司 (Laishang Bank).pdf",
  "西安银行股份": "西安银行股份有限公司 (Bank of Xi'an).pdf",
  "贵州省农村信": "贵州省农村信用社联合社 (Guizhou Rural Credit Union).pdf",
  "贵州银行股份": "贵州银行股份有限公司 (Bank of Guizhou).pdf",
  "达州银行股份": "达州银行股份有限公司 (Bank of Dazhou).pdf",
  "通用技术集团": "通用技术集团财务有限责任公司 (Genertec Finance).pdf",
  "遂宁银行股份": "遂宁银行股份有限公司 (Suining Bank).pdf",
  "鄂尔多斯银行": "鄂尔多斯银行股份有限公司 (ORDOS Bank).pdf",
  "重庆三峡银行": "重庆三峡银行 (Chongqing Three Gorges Bank).pdf",
  "重庆银行股份": "重庆银行股份有限公司 (Bank of Chongqing).pdf",
  "雅安市商业银": "雅安市商业银行股份有限公司 (Yaan City Commercial Bank).pdf",
  "青岛银行股份": "青岛银行股份有限公司 (BQD).pdf",
  "齐商银行股份": "齐商银行股份有限公司 (Qishang Bank).pdf",
  "齐鲁银行股份": "齐鲁银行股份有限公司 (Qilu Bank).pdf",
  "龙江银行股份": "龙江银行股份有限公司 (Longjiang Bank).pdf",
  "澳门国际银行": "澳门国际银行股份有限公司 (LUSO INTERNATIONAL BANKING LTD.).pdf",
  "南方电网财务": "南方电网财务有限公司 (China Southern Power Grid Corporation Finance Co., Ltd.).pdf",
  "特变电工集团": "特变电工集团财务有限公司 (TBEA Co., Ltd.).pdf",
  "星展银行（中": "星展银行（中国）有限公司 (DBS Bank China Ltd).pdf",
  "中银富登村镇": "中银富登村镇银行 (BOC Fullerton Community Bank).pdf"
}